import React from 'react';
import styled from 'styled-components/macro';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import cx from 'classnames';
import { Tooltip } from 'src/client/components/ui/Tooltip';
import { DESKTOP, TABLET_LANDSCAPE } from 'src/client/constants/mediaQueries';
import { ImageButton, NavbarIcon } from './styles';

type Props = {
  onToggleSearchBar: () => void;
  searchBarOpen: boolean;
  searchToggleRef: React.RefObject<HTMLDivElement>;
};

export const SearchButton = (props: Props) => {
  const { onToggleSearchBar, searchBarOpen, searchToggleRef } = props;

  return (
    <Tooltip value="Search" placement="bottom">
      <StyledImageButton
        ref={searchToggleRef}
        className={cx('clickable', { active: searchBarOpen })}
        onClick={onToggleSearchBar}
      >
        <NavbarIcon icon={faSearch} />
      </StyledImageButton>
    </Tooltip>
  );
};

const StyledImageButton = styled(ImageButton)`
  display: none;
  cursor: pointer;

  @media ${TABLET_LANDSCAPE} {
    display: block;
    .is-guest & {
      margin-right: -2px;
    }
  }

  @media ${DESKTOP} {
    .is-guest & {
      margin-right: -5px;
    }
  }
`;
